import React, { useState } from 'react';
import { X } from 'lucide-react';
import { businessMappingService } from '../../../services/businessApi';

const STATUS_OPTIONS = ['not_started', 'done', 'blocked', 'planned', 'not_applicable'];

export default function StepEditorModal({ mappingId, entry, stepName, supplierName, plantName, onClose, onSaved }) {
  const [status, setStatus] = useState(entry.status);
  const [statusDate, setStatusDate] = useState(entry.statusDate ? entry.statusDate.slice(0, 10) : '');
  const [comment, setComment] = useState(entry.comment || '');
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState('');

  const handleSave = async () => {
    setSaving(true);
    setError('');
    try {
      await businessMappingService.updateStep(mappingId, entry._id, {
        status,
        statusDate: statusDate || null,
        comment: comment || null,
      });
      onSaved();
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to update step');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="drawer-overlay" onClick={onClose}>
      <div className="client-form-modal" style={{ margin: 'auto', width: 420 }} onClick={e => e.stopPropagation()}>
        <div className="modal-header">
          <h3>{stepName}</h3>
          <button className="icon-btn-sm" onClick={onClose}><X size={16} /></button>
        </div>
        <div className="client-form">
          <div className="form-section-title">{supplierName} · {plantName}</div>

          {error && <div className="form-error">{error}</div>}

          <div className="form-group">
            <label>Status</label>
            <select value={status} onChange={e => setStatus(e.target.value)}>
              {STATUS_OPTIONS.map(s => <option key={s} value={s}>{s.replace('_', ' ')}</option>)}
            </select>
          </div>

          <div className="form-group">
            <label>Status date (optional)</label>
            <input type="date" value={statusDate} onChange={e => setStatusDate(e.target.value)} />
          </div>

          <div className="form-group">
            <label>Comment (optional)</label>
            <textarea rows={3} value={comment} onChange={e => setComment(e.target.value)} placeholder="e.g. PO not visible in L-Setu" />
          </div>

          <div className="modal-footer">
            <button className="btn btn-ghost" onClick={onClose}>Cancel</button>
            <button className="btn btn-primary" onClick={handleSave} disabled={saving}>
              {saving ? 'Saving...' : 'Save'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
